import { makeStyles } from '@material-ui/core';
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export default function PlateSamplingHeader(props) {
    const classes = useStyles();
    const { t } = useTranslation();

    return (
        <div className={classes.header}>
            <div className={classes.headerColumn1}>
                {t("Plate sampling")}
           </div>
            <div className={classes.headerColumn2}>
                <div className={classes.infoTitle}>{t("Line")}</div>
                <div className={classes.info}>{props.productionOrder.machineCode}</div>
            </div>
            <div className={classes.headerColumn3}>
                <div className={classes.infoTitle}>Order</div>
                <div className={classes.info}>{props.productionOrder.reference}</div>
            </div>
            <div className={classes.headerColumn4}>
                <div className={classes.infoTitle}>{t("Client")}</div>
                <div className={classes.info}>{props.productionOrder.customerName}</div>
            </div>
            <div className={classes.headerColumn5}>
                <div className={classes.infoTitle}>{t("Article")}</div>
                <div className={classes.info}>{props.productionOrder.bomOut[0].productReference}</div>
            </div>
        </div>
    )
}

const useStyles = makeStyles({
    header: {
        width: "100%",
        height: "60px",
        paddingTop:"30px", 
        borderBottom:"1px solid #DEDEDE" ,
        position:"fixed" ,
        zIndex:"1" ,
        backgroundColor:"#EFEFEF"    
    },
    headerColumn1:{
        width:"30%",
        boxSizing:"border-box",
        float:"left",
        color: "#000000",
        fontSize: "32px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium'
    },
    headerColumn2:{
        width:"5%",
        boxSizing:"border-box",
        float:"left",
    },
    headerColumn3:{
        width:"15%",
        boxSizing:"border-box",
        float:"left",
    },
    headerColumn4:{
        width:"25%",
        boxSizing:"border-box",
        float:"left",
    },
    headerColumn5:{
        width:"25%",
        boxSizing:"border-box",
        float:"left",
    },
    infoTitle:{
        color: "#8D8D8D",
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        marginBottom:"5px"
    },
    info:{
        color: "#000000",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium'
    }
});